import { Phone, MessageCircle, MapPin, Mail, Instagram } from "lucide-react";
import { waLink, LOGO_URL, INSTAGRAM_URL } from "../../lib/constants";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Sobre", href: "#sobre" },
  { label: "O Que É?", href: "#oquee" },
  { label: "Diagnóstico e Tratamento", href: "#diagnostico" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Convênios", href: "#convenios" },
  { label: "FAQ", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A1929] text-white pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Logotipo Dr. Mateus Marques - Cirurgião Torácico"
                className="h-14 w-auto"
                width="56"
                height="56"
              />
              <div>
                <div className="font-poppins font-bold text-white text-lg">Dr. Mateus Marques</div>
                <div className="text-white/60 text-xs">Cirurgião Torácico · CRM-BA 28.632</div>
              </div>
            </div>
            <p className="text-white/65 text-sm leading-relaxed max-w-md">
              Cirurgião Torácico especializado em derrame pleural em Feira de Santana - BA.
              Diagnóstico preciso e tratamento seguro com técnicas minimamente invasivas
              (toracocentese, drenagem pleural e pleuroscopia VATS).
            </p>
            <div className="flex flex-wrap gap-3 mt-5">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 bg-[#25D366] text-white font-poppins font-semibold text-sm px-4 py-2.5 rounded-full hover:bg-[#1da851] transition-colors"
              >
                <MessageCircle size={16} /> WhatsApp
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/15 text-white font-poppins font-semibold text-sm px-4 py-2.5 rounded-full transition-colors"
              >
                <Instagram size={16} /> @drmateus_cirtorax
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-poppins font-bold text-sm uppercase tracking-wide text-white/90 mb-4">
              Navegação
            </h4>
            <ul className="space-y-2">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-white/65 hover:text-white text-sm transition-colors"
                    data-testid={`footer-nav-${l.href.replace("#", "")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-poppins font-bold text-sm uppercase tracking-wide text-white/90 mb-4">
              Contato
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>Feira de Santana, BA</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 flex-shrink-0" />
                <span>(75) 98187-2440</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 flex-shrink-0" />
                <span>Seg a Sex · 8h–18h</span>
              </li>
              <li className="flex items-start gap-2">
                <Instagram size={16} className="mt-0.5 flex-shrink-0" />
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                  data-testid="footer-instagram-link"
                >
                  @drmateus_cirtorax
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/45 text-xs text-center md:text-left">
            © {new Date().getFullYear()} Dr. Mateus Marques · Cirurgião Torácico. Todos os direitos reservados.
          </p>
          <p className="text-white/35 text-xs text-center md:text-right max-w-xl">
            Conteúdo educativo sobre derrame pleural. Não substitui consulta médica. Avaliação
            individualizada sempre necessária.
          </p>
        </div>
      </div>
    </footer>
  );
}
